module.exports = __webpack_public_path__ + "img/product_40.cd385c7.svg";